/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
// utils
import {
  Translations,
  convertStringToArrayForOption,
  convertStringToArrayForRadio,
  loadIfStateAvailableInSessionStorage
} from '../../../../utils';
// constant
import { FORM_REFS } from '../../../../constants';
// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../../restClient';
// children
import Checkbox from '../../../common/Checkbox';
import {
  ActionBar,
  CompositeList,
  CompositeListItem,
  ItemHeading,
  ListMiddleContentSection,
  ListRightContentSection
} from '../../../common/CompositeList/compositeList';
import Dynamicform from '../../../common/Dynamicform/dynamicForm';
import MultiLineSelect from '../../../common/MultiLineSelect';
import NavListAccordion, { NavListAccordionWrapper } from '../../../common/NavListAccordion/NavListAccordion';
import PersistLink from '../../../common/PersistLink';
import IEDetailSetting from './IEDetailSetting/';
import IETireSetting from './IETireSetting';
//action Creator
import { setCurrentProductEchannel } from '../../actions/actionCreator';
import {
  resetDeletedtTierIndex,
  setIETabStatus,
  setInterestEnhancementAccounts,
  setInterestEnhancementDetail,
  setPremiumMarginValue
} from './actions/actionCreator';
//style
import './style.css';

//dummy data
import classNames from 'classnames';

/*------------IE Tire setting--------------------*/
// Add country page
//  PUT: product/gls/:glsId/account/:accountId
//  GET: product/gls/:glsId/case/:caseId/account
//  POST: product/gls/:glsId/account
//
//
// GET :product/taxonomies/cashConcentrationCountries

/*-----------End of Tier Se*/

class CaptureProductGlsInterestEnhancement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noOfReporting: 1,
      echannels: [],
      reportedEChannelId: '',
      eChannelReported: '',
      formRef: {},
      lang: '',
      glsData: {},
      dataReady: false,
      tierData: {},
      addedTiers: [],
      updatedDetailedSettings: [],
      premiumMarginVal: typeof this.props.interestEnhancement !== 'undefined' ? this.props.interestEnhancement.marginApplicable : '' || '',
      interestEnhancementTitle: typeof this.props.interestEnhancement !== 'undefined' ? this.props.interestEnhancement.interestEnhancementTitle : '' || '',
    };
    this.reportingEchannelDisableList = [];
    this.payload = new payloadIE();
    this.basicDetailPayload = new payloadBasicDetail();
    this.detailSettingPayload = new payloadIeDetailSetting();
    this.tierSettingPayload = new payloadIeTierSetting();
    this.EchannelReportingSection = new EchannelReportingSection();
    this.dataDictionaryURI = '';

  }
  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForOption(currentWord);
    return convertedArray;
  }

  translateWordForRadio = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForRadio(currentWord);
    return convertedArray;
  }

  loadPageState = () => {
    var { productId } = this.props.match.params;
    const apiURL = "/product/gls/" + productId;

    // Get Product detail
    eapiClient(apiURL, {
      method: 'GET'
    })
      .then(({ data }) => {
        this.props.setInterestEnhancementDetail(data.responseData);
        this.setState({
          glsData: data.responseData,
          countryList: data.responseData.interestEnhancement.countryAndAccount,
          tierData: data.responseData.interestEnhancement.tierSettings,
          dataReady: true,
          reportedEChannelId: data.responseData.interestEnhancement.reportedEChannelId,
          eChannelReported: typeof data.responseData.interestEnhancement.eChannelReported === "boolean" ? data.responseData.interestEnhancement.eChannelReported : '',
        }, () => {
          var localObj = {
            name: 'EChannelReporting',
            value: this.state
          }
          this.payload.setPayload(localObj)
        })
        this.getTaxanomyUrl();
      });

  }

  componentWillMount() {
    const { productId, caseId } = this.props.match.params;

    aemHostClient("/aemData/formData/json_interest-enhancement")
      .then(({ data }) => {
        this.setState({ pageJson: data.par });
        this.getCaseEChannels()
      });

    loadIfStateAvailableInSessionStorage(this, null, () => {
      this.loadPageState();
    });

    eapiClient(`/product/gls/${productId}/case/${caseId}/account`)
      .then(({ data }) => {
        this.props.setInterestEnhancementAccounts(data.responseData);
      })

    aemHostClient("/aemData/formData/json_add-country-and-accounts")
      .then(({ data }) => {
        this.setState({
          addCountryAndAccountsJson: data.par
        });
      });

    aemHostClient("/aemData/formData/json_gls_echannel_reporting")
      .then(({ data }) => {
        this.setState({
          json_echannelReporting: data.par
        });
      });
    // get tab status
    this.loadTabStatus();
  }

  componentDidMount() {
    this.setState({
      lang: this.props.lang.currentLang.lang
    })

    var getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    var getCurrentDropDownValue = window.sessionStorage.getItem('key' + getCurrentDropDown);
    var _eChannelReporting = this.state.reportedEChannelId;

    if (getCurrentDropDown !== null) {
      var getCurrentDropDownName = getCurrentDropDown.substring(0, getCurrentDropDown.length - 1);
    }

    if (getCurrentDropDownName === 'eChannelReporting') {
      var getCurrentDropDownIndex = getCurrentDropDown.substring(getCurrentDropDown.length - 1);
    }

    if (getCurrentDropDownName === 'eChannelReporting' && getCurrentDropDownValue !== null) {
      _eChannelReporting = getCurrentDropDownValue;
      let disableItem = _eChannelReporting
      this.reportingEchannelDisableList = [disableItem]
      this.setState({
        reportedEChannelId: _eChannelReporting,
        disabledeChannelReporting: disableItem,
        eChannelReported: false
      }, () => {
        var localObj = {
          name: 'EChannelReporting',
          value: this.state
        }
        this.payload.setPayload(localObj);
        this.EchannelReportingSection.setEchannelReporting(localObj)
      });
    }

    if (getCurrentDropDown && getCurrentDropDown.includes("glsReports")) {
      const [fieldName, accIndex, glsReportIndex] = getCurrentDropDown.split("-") || []
      const newDetailedSettings = (this.state.glsData && this.state.glsData.interestEnhancement && this.state.glsData.interestEnhancement.detailedSettings) || []
      if (newDetailedSettings && newDetailedSettings[accIndex] && newDetailedSettings[accIndex][fieldName]) {
        newDetailedSettings[accIndex][fieldName][glsReportIndex] = getCurrentDropDownValue
      }
      this.props.setInterestEnhancementDetail({ ...this.state.glsData, detailedSettings: newDetailedSettings })
    }

    window.sessionStorage.removeItem("getCurrentDropDown");
    window.sessionStorage.removeItem('key' + getCurrentDropDown);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      this.getTaxanomyUrl();
    }
    let disableItem = this.state.reportedEChannelId
    this.reportingEchannelDisableList = [disableItem]
    this.setState({
      reportedEChannelId: this.state.reportedEChannelId,
      disabledeChannelReporting: disableItem
    });
  }

  getTaxanomyUrl = () => {
    this.dataDictionaryURI = this.state.pageJson !== undefined && this.state.pageJson.aemform_tiersAndSettings && this.state.pageJson.aemform_tiersAndSettings.settlementDateTaxonomy ? this.translations(this.state.pageJson.aemform_tiersAndSettings.settlementDateTaxonomy) : '';
    this.state.pageJson !== undefined && this.getInterestPeriodSettlementDate()
  }

  getInterestPeriodSettlementDate = () => {
    let echannels = this.state.echannels;
    let countryList = this.state.countryList || this.props.accounts;
    taxonomyHostClient(this.translations(this.state.pageJson.aemform_echannelReporting.countryTaxonomy))
      .then(({ data }) => {
        if (data.responseData !== undefined) {
          let currentListCountries = data.responseData.classificationNodes;
          if (echannels !== undefined) {
            echannels = echannels.map(item => {
              currentListCountries.filter(countItem => {
                if ('country' in item) {
                  if (countItem.id === item.country.value) {
                    item.country.name = countItem.name
                  }
                }
                return item;
              });

              this.setState([...echannels]);
            });
          }

          if (countryList !== undefined) {
            countryList = countryList.map(item => {
              currentListCountries.filter(countItem => {
                if ('country' in item) {
                  if (countItem.id === item.country.value) {
                    item.country.name = countItem.name
                  }
                }
                return item;
              });

              this.setState([...countryList]);
            });
          }
        }
      });
  }

  loadTabStatus = () => {
    let { productId, caseId } = this.props.match.params;
    let tabStatus;

    if (this.props.history.location.state !== undefined && this.props.history.location.state.isNavigate !== undefined) {
      tabStatus = `/product/gls/${productId}/InterestEnhancementStatus`;
    } else {
      tabStatus = `/product/gls/${productId}/InterestEnhancementStatus`;
    }
    eapiClient(tabStatus, { method: 'GET' })
      .then(({ data }) => {
        this.props.setIETabStatus(data.responseData);
      });
  }

  getBasicDetails = (args) => {
    if (args.interestEnhancementTitle) {
      let _data = {
        name: 'basicDetails',
        value: args
      }
      this.payload.setPayload(_data);
      this.basicDetailPayload.setPayload(_data);
      this.setState({
        interestEnhancementTitle: args.interestEnhancementTitle,
        premiumMarginVal: args.marginApplicable
      });
      this.props.setPremiumMarginValue(args.marginApplicable)
    } else {
      let _data = {
        name: 'basicDetails',
        value: args
      }
      this.payload.setPayload(_data);
      this.basicDetailPayload.setPayload(_data);
      this.setState({
        interestEnhancementTitle: '',
        premiumMarginVal: args.marginApplicable
      });
      this.props.setPremiumMarginValue(args.marginApplicable)
    }
  }

  renderBasicDetailForm = () => {
    let formData;
    let mode;
    if (this.props.interestEnhancement !== undefined) {
      formData = this.props.interestEnhancement;
      mode = "edit";
    } else {
      formData = {};
      mode = '';
    }
    const properties = {
      formData,
      editType: 'gls-interest-enhancement',
      pathname: this.props.location.pathname
    };

    if (this.state.dataReady && this.state.pageJson !== undefined && this.state.pageJson.aemform_basicDetails !== undefined) {
      var aemform = this.state.pageJson.aemform_basicDetails;
      var formRef = this.state.pageJson.aemform_basicDetails.formRef;
      var pageTitle = this.state.pageJson.aemform_basicDetails.title;
      if (aemform !== undefined && formRef !== undefined) {
        var url = FORM_REFS[formRef];

        return (
          <Dynamicform
            mode={mode}
            flag="true"
            properties={properties}
            hideButtons={true}
            saveButton={true}
            onFormSubmit={this.onBasicDetailTabDataSubmit}
            pageTitle={pageTitle}
            // hideButtons={true}
            getFormData={this.getBasicDetails}
            url={url}
            lang={this.props.lang.currentLang.lang}
            translatedData={this.props.lang.translatedData}
            resetDisable={true}
          />

        );
      }
    }
  }

  onBasicDetailTabDataSubmit = (event, apiUrl) => {
    let requestedObj = this.basicDetailPayload.getPayload();
    var { productId } = this.props.match.params;
    if (typeof requestedObj.interestEnhancementTitle !== 'undefined' ||
      typeof requestedObj.marginApplicable !== 'undefined' ||
      typeof requestedObj.interestEnhancement !== 'undefined') {
      const apiURL = apiUrl + productId;
      eapiClient(apiURL, {
        method: 'PUT',
        data: JSON.stringify(requestedObj)
      })
        .then(({ data }) => {
          this.props.setInterestEnhancementDetail(data.responseData);
          this.loadTabStatus();
        });
    }
  }

  onIeTierAndSettingTabDataSubmit = () => {
    let requestedObj = this.tierSettingPayload.getPayload();

    if (this.detailSettingPayload.getPayload() && this.detailSettingPayload.getPayload().interestEnhancement) {
      requestedObj.interestEnhancement = {
        ...requestedObj.interestEnhancement, detailedSettings: this.detailSettingPayload.getPayload().interestEnhancement.detailedSettings
      }
    }

    var { productId } = this.props.match.params;
    if (typeof requestedObj.interestEnhancementTitle !== 'undefined' ||
      typeof requestedObj.marginApplicable !== 'undefined' ||
      typeof requestedObj.interestEnhancement !== 'undefined') {
      const apiURL = "/product/gls/" + productId;
      eapiClient(apiURL, {
        method: 'PUT',
        data: JSON.stringify(requestedObj)
      })
        .then(({ data }) => {
          this.props.setInterestEnhancementDetail(data.responseData);
          this.loadTabStatus();
        });
    }
  }

  onIeDetailSettingTabDataSubmit = () => {
    let requestedObj = this.detailSettingPayload.getPayload();
    var { productId } = this.props.match.params;

    if (requestedObj.interestEnhancement && requestedObj.interestEnhancement.detailedSettings && requestedObj.interestEnhancement.detailedSettings.length) {
      let pools = requestedObj.interestEnhancement.detailedSettings;
      if (pools.length > 0) {
        for (let i = 0; i < pools.length; i++) {
          if (pools[i].productParticipatingIn && !pools[i].productParticipatingIn.name) {
            delete pools[i].productParticipatingIn
          }
        }
      }
    }

    if (typeof requestedObj.interestEnhancementTitle !== 'undefined' ||
      typeof requestedObj.marginApplicable !== 'undefined' ||
      typeof requestedObj.interestEnhancement !== 'undefined') {
      const apiURL = "/product/gls/" + productId;
      eapiClient(apiURL, {
        method: 'PUT',
        data: JSON.stringify(requestedObj)
      })
        .then(({ data }) => {
          this.props.setInterestEnhancementDetail(data.responseData);
          this.loadTabStatus();
        });
    }
  }

  submitForm = () => {
    let requestedObj = this.payload.getPayload();
    var { productId } = this.props.match.params;
    if (requestedObj.interestEnhancement && requestedObj.interestEnhancement.detailedSettings && requestedObj.interestEnhancement.detailedSettings.length) {
      let pools = requestedObj.interestEnhancement.detailedSettings;
      if (pools.length > 0) {
        for (let i = 0; i < pools.length; i++) {
          if (pools[i].productParticipatingIn && !pools[i].productParticipatingIn.name) {
            delete pools[i].productParticipatingIn
          }
        }
      }
    }
    if (typeof requestedObj.interestEnhancementTitle !== 'undefined' ||
      typeof requestedObj.marginApplicable !== 'undefined' ||
      typeof requestedObj.interestEnhancement !== 'undefined') {
      const apiURL = "/product/gls/" + productId;
      eapiClient(apiURL, {
        method: 'PUT',
        data: JSON.stringify(requestedObj)
      })
        .then(({ data }) => {
          this.props.setInterestEnhancementDetail(data.responseData);
          this.setState({
            glsData: data.responseData,
            countryList: data.responseData.interestEnhancement.countryAndAccount,
            tierData: data.responseData.interestEnhancement.tierSettings,
            dataReady: true
          });
          this.props.history.push('/case-body');
        });
    } else {
      ///this.props.history.push('/case-body');
    }
  }

  validateIETierSettings = (tierSettings = [], detailedSettings = []) => {

  }

  // Delete composit list country
  deleteCountry = (item) => {
    var { productId } = this.props.match.params;
    const apiURL = "/product/gls/" + productId;
    let deleteGroup = '/product/gls/' + productId + '/cancelCountryGroup/' + item.id;
    eapiClient(deleteGroup,
      {
        method: 'DELETE'
      })
      .then(({ data }) => {
        this.props.setInterestEnhancementDetail(data.responseData);
        var displayCountry = data.responseData.interestEnhancement.countryAndAccount.filter(item => {
          var str = item.status.includes('delete')
          if (str) {
            return false
          } else {
            return item
          }
        })

        this.setState({
          countryList: displayCountry,
          updatedDetailedSettings: data.responseData.interestEnhancement.detailedSettings
        })
        // get tab status

        // get tab status
        this.loadTabStatus();
        eapiClient(apiURL, {
          method: 'GET'
        })
          .then(({ data }) => {
            this.props.setInterestEnhancementDetail(data.responseData);
          });

      })

  }
  goToFormEdit = (event, id, lid) => {
    var { caseId, productId } = this.props.match.params;
    if (id !== 'undefined' && lid !== 'undefined') {
      let editPath = '/case-body/capture-product-interest-enhancement/add-country-and-account/' + caseId + '/' + productId;
      this.props.history.push({
        pathname: editPath,
        state: {
          id: id,
          lid: lid,
          mode: 'edit'
        }
      });
    }
  }

  getIETierAndSettingData = (data) => {
    var localObj = {
      name: 'IEDetailSetting',
      value: data
    }
    this.payload.setPayload(localObj);
    this.detailSettingPayload.setPayload(localObj);
  }

  IETireSettingData = (data) => {
    let tet = {};
    let resetTier = []
    if (data.interestEnhancement.tierSettings.tiers !== undefined) {
      data.interestEnhancement.tierSettings.tiers.map(item => {
        tet.balanceForEnhancementMargin = ''
        tet.balanceEligibleAccountsForPremiumMargin = ''
        tet.tierId = null
        resetTier.push(tet);
      })
      this.setState({
        addedTiers: resetTier
      })
    }
    var localObj = {
      name: 'IETireSetting',
      value: data.interestEnhancement
    }
    this.payload.setPayload(localObj);
    this.tierSettingPayload.setPayload(localObj);
  }

  resetDeletedIndex = () => {
    this.props.resetDeletedtTierIndex()
  }

  countryName = (name) => {
    let countryArray = name.split(':')
    let valLen = countryArray.length;
    let countryName = countryArray[valLen - 2]

    return countryName.replace(/([a-z](?=[A-Z]))/g, '$1 ');
  }

  //New Feature

  // E-channel Reporting handler
  handleReportingChange = (index, data) => {
    let eChannel = this.state.reportedEChannelId
    eChannel = data.id

    this.reportingEchannelDisableList.indexOf(data.id) === -1 && this.reportingEchannelDisableList.includes(data.id)
      ? this.reportingEchannelDisableList.push(data.id)
      : this.reportingEchannelDisableList

    this.reportingEchannelDisableList[index] = data.id

    this.setState({
      reportedEChannelId: eChannel,
      eChannelReported: false
    }, () => {
      var localObj = {
        name: 'EChannelReporting',
        value: this.state
      }
      this.payload.setPayload(localObj);
      this.EchannelReportingSection.setEchannelReporting(localObj)
    })

  }

  // setShouldReportToEchannel = (value, name) => {
  //   if (value === true) {
  //     this.setState({
  //       eChannelReported: value
  //     }, () => {
  //       var localObj = {
  //         name: 'EChannelReporting',
  //         value: this.state
  //       }
  //       this.payload.setPayload(localObj);
  //       this.EchannelReportingSection.setEchannelReporting(localObj)
  //     });
  //   } else {
  //     this.setState({
  //       eChannelReported: value,
  //       reportedEChannelId: '',
  //       disabledeChannelReporting: []
  //     }, () => {
  //       var localObj = {
  //         name: 'EChannelReporting',
  //         value: this.state
  //       }
  //       this.payload.setPayload(localObj);
  //       this.EchannelReportingSection.setEchannelReporting(localObj)
  //     });
  //     this.reportingEchannelDisableList = []
  //   }
  // }

  // Render E-Channel Reporting Section
  renderReportingSection = () => {
    let reporting_Jsx = [];
    for (var i = 0; i < this.state.noOfReporting; i++) {
      reporting_Jsx.push(
        <div className="reporting-container">
          <div className="reporting-section">
            <label className="reporting-section_label">{this.translations(this.state.pageJson.aemform_echannelReporting.eChannel)}</label>
            <div className="reporting-section_div">
              <MultiLineSelect
                defaultValue={this.translations(this.state.pageJson.aemform_echannelReporting.pleaseSelect)}
                requiredFields={{
                  "row1": ["eChannelType", "country"],
                  "row2": ["profileOwner"],
                  "row3": []
                }}
                formatters={{
                  "row1": [null, (data, fieldValue) => data.newEchannel ? `${fieldValue} (New)` : `${fieldValue} (Existing)`, null],
                  "row2": [],
                  "row3": []
                }}
                data={this.state.echannels && this.state.echannels.filter(echannel => echannel.eChannelType.name === "HSBCnet") || []}
                value={this.state.reportedEChannelId !== undefined && this.state.reportedEChannelId !== '' ? this.state.reportedEChannelId : ''}
                disabledOptions={this.reportingEchannelDisableList}
                multiAccount={true}
                _onChange={this.handleReportingChange.bind(this, i)}
                isDisable={this.props.customer.roleDetails.customer || this.state.eChannelReported}
              />
              <span className="icon icon-add addicon" disabled={this.state.eChannelReported}></span>
              <PersistLink
                className="mrg-left"
                to={'/case-body/create-new-product-echannel/isEchannelRestricted'}
                history={this.props.history}
                state={this.state}
                data={`eChannelReporting${i}`}
                isDisable={this.props.customer.roleDetails.customer || this.state.eChannelReported}
              >
                {this.translations(this.state.pageJson.aemform_echannelReporting.addEchannel)}
              </PersistLink>
            </div>
          </div>
        </div>
      )
    }
    return reporting_Jsx;
  }

  // Save and Refresh Sumbit for Reporting Section
  onSubmitReportingSectionData = () => {
    let payload = new EchannelReportingSection()
    payload.setEchannelReporting(this.state);

    var { productId } = this.props.match.params;
    const apiURL = "/product/gls/" + productId;
    eapiClient(apiURL, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        this.props.setInterestEnhancementDetail(data.responseData);
        this.loadTabStatus();
      });
  }

  _checkboxHandler = (event) => {
    this.setState({
      eChannelReported: event.target.checked
    }, () => {
      const eChannelReportingObject = {
        name: 'EChannelReporting',
        value: this.state
      }
      this.payload.setPayload(eChannelReportingObject);
      this.EchannelReportingSection.setEchannelReporting(eChannelReportingObject)
    })
  }

  getCaseEChannels = () => {
    const { caseId } = this.props.match.params;
    eapiClient("/product/caseRelatedEchannel/case/" + caseId)
      .then(({ data }) => {
        this.setState({
          echannels: data.responseData
        })
      });
  }

  render() {
    if (typeof this.props.interestEnhancement !== 'undefined' && this.state.addCountryAndAccountsJson !== undefined && this.state.pageJson !== undefined && this.state.pageJson.page_title_mainTitle !== undefined) {
      var { caseId, productId } = this.props.match.params;
      const { refrenceId, glsAgent, interestEnhancementTitle, interestEnhancement } = this.props.interestEnhancement;
      this.dataDictionaryURI = this.state.pageJson !== undefined && this.state.pageJson.aemform_tiersAndSettings && this.state.pageJson.aemform_tiersAndSettings.settlementDateTaxonomy ? this.translations(this.state.pageJson.aemform_tiersAndSettings.settlementDateTaxonomy) : '';

      document.title = (refrenceId && this.state.pageJson !== undefined && this.state.pageJson.page_title_mainTitle !== undefined)
        ? `${"Product Requests"} - ${"Review Product"} - ${this.translations(this.state.pageJson.page_title_mainTitle.pageHeading)} ${refrenceId} - ${'HSBC GLCM'}`
        : `${"Product Requests"}- ${'HSBC GLCM'}`;

      return (
        <div className="customer-details-container">
          <div className="pannel-heading-container">
            <div><h2 className="pannel-heading">{this.translations(this.state.pageJson.page_title_mainTitle.pageHeading)} <span>({refrenceId})</span></h2></div>
            <p className="pannel-sub-heading">{`${this.translations(this.state.pageJson.page_title_mainTitle.agent)}: ${glsAgent && typeof glsAgent.name !== 'undefined' ? glsAgent.name : ''}`} {interestEnhancementTitle !== undefined && interestEnhancementTitle.length > 0 ? `(${interestEnhancementTitle})` : ''}</p>
            <p className="optional-text"><b>{this.translations(this.state.pageJson.page_title_mainTitle.descriptionText)}</b></p>
          </div>

          <div className="gdocs-clear-float"></div>
          <NavListAccordionWrapper>
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={`1. ${this.translations(this.state.pageJson.aemform_basicDetails.title)}`}
              status={this.props.tabStatus !== undefined ? this.props.tabStatus && this.props.tabStatus.basicDetails && this.props.tabStatus.basicDetails.status : ''}
            >
              <div>{this.renderBasicDetailForm()}</div>
            </NavListAccordion>
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={`2. ${this.translations(this.state.pageJson.aemform_countriesAccounts.title)}`}
              status={this.props.tabStatus !== undefined ? this.props.tabStatus && this.props.tabStatus.countriesAndAccounts && this.props.tabStatus.countriesAndAccounts.status : ''}
            >
              <div className="addresses-section">
                <div className="gdocs-mtop-20">
                  <CompositeList>
                    {
                      this.state.countryList !== undefined
                        ? this.state.countryList.map((item, key) => {
                          var accountCount = item.accounts.length;
                          var premiumCount = item.accounts.filter(key => key.premiumMargin).length;
                          return (
                            <CompositeListItem key={key}>
                              <ListRightContentSection>
                                <ItemHeading lid={item.lid} id={item.id} _onClick={this.goToFormEdit} showArrowIcon={false}><a >{item.country.name}</a></ItemHeading>
                              </ListRightContentSection>
                              <ListMiddleContentSection>
                                <span>{`${accountCount} ${this.translations(this.state.addCountryAndAccountsJson.static_text_addCountry.accounts)} (${premiumCount} ${this.translations(this.state.addCountryAndAccountsJson.static_text_addCountry.premium)})`}</span>
                              </ListMiddleContentSection>
                              {
                                !this.props.customer.roleDetails.customer
                                  ? <ActionBar _onClick={this.deleteCountry.bind(this, item)} />
                                  : ''
                              }
                            </CompositeListItem>)
                        })
                        : ''
                    }
                  </CompositeList>
                  <div className="gdocs-mtop-10 gdocs-mbottom-10">
                    <Link
                      className={`add-county-btn ${this.props.customer.roleDetails.customer ? 'disabled' : ''}`}
                      to={'/case-body/capture-product-interest-enhancement/add-country-and-account/' + caseId + '/' + productId}
                    >
                      <i className="icon icon-add"></i>{this.translations(this.state.addCountryAndAccountsJson.static_text_addCountry.addCountryBtnText)}
                    </Link>
                  </div>
                </div>
                <div className="gdocs-clear-float"></div>
              </div>
            </NavListAccordion>
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={`3. ${this.translations(this.state.pageJson.aemform_echannelReporting.eChannelRep)}`}
              status={this.props.tabStatus !== undefined && this.props.tabStatus.echannelReporting !== undefined ? this.props.tabStatus && this.props.tabStatus.echannelReporting && this.props.tabStatus.echannelReporting.status : ''}
            >
              <div className="reporting">
                <p>
                  {this.translations(this.state.pageJson.aemform_echannelReporting.eChannelHSBCnetInfoone)}<br />
                  {this.translations(this.state.pageJson.aemform_echannelReporting.eChannelHSBCnetInfotwo)}
                </p>
                {this.renderReportingSection()}
                <div className={classNames("reporting-section", { "disabled": Boolean(this.state.reportedEChannelId) })}>
                  <label className="reporting-section_label">
                    {this.translations(this.state.pageJson.aemform_echannelReporting.eChannelCheckBox)}
                  </label>
                  <div
                    className="reporting-section_div"
                    role="radiogroup"
                    aria-label={this.translations(this.state.pageJson.aemform_echannelReporting.eChannelCheckBox)}
                  >
                    <Checkbox
                      name="setShouldReportToEchannel"
                      id="setShouldReportToEchannel"
                      checked={this.state.eChannelReported}
                      onChange={this._checkboxHandler}
                      disabled={Boolean(this.state.reportedEChannelId)}
                      controlled
                    />
                  </div>
                </div>
                <div className="gdocs-clear-float"></div>
                <div className="gdocs-float-right form-buttons-save-section">
                  <button onClick={this.onSubmitReportingSectionData} className='btn save-btn'>{this.translations(this.state.pageJson.aemform_echannelReporting.saveAndRefresh)}</button>
                </div>
                <div className="gdocs-clear-float"></div>
              </div>
            </NavListAccordion>

            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={`4. ${this.translations(this.state.pageJson.aemform_tiersAndSettings.title)}`}
              status={this.props.tabStatus !== undefined ? this.props.tabStatus && this.props.tabStatus.tierSettings && this.props.tabStatus.tierSettings.status : ''}
            >
              <div className="addresses-section">
                <div>
                  <IETireSetting
                    IETireSettingData={this.IETireSettingData}
                    {...this.props.interestEnhancement}
                    premiumMargin={this.state.premiumMarginVal}
                    lang={this.props.lang}
                    ieTireSettingTabData={this.onIeTierAndSettingTabDataSubmit}
                    dataDictionaryURI={this.dataDictionaryURI}
                  />
                </div>
              </div>
            </NavListAccordion>
            {
              this.state.countryList !== undefined && this.state.countryList.length > 0 &&
              <NavListAccordion
                lang={this.props.lang.currentLang.lang}
                navAccHeading={`5. ${this.translations(this.state.pageJson.aemform_detailedSettings.title)}`}
                status={this.props.tabStatus !== undefined ? this.props.tabStatus && this.props.tabStatus.detailedSettings && this.props.tabStatus.detailedSettings.status : ''}
              >
                <div className="addresses-section">
                  <div>
                    <IEDetailSetting
                      getIETierAndSettingData={this.getIETierAndSettingData}
                      {...this.props.interestEnhancement}
                      newTiers={this.state.addedTiers}
                      deletedIndex={this.props.deletedIndex}
                      _resetDeletedIndex={this.resetDeletedIndex}
                      premiumMargin={this.state.premiumMarginVal}
                      disabled={this.props.customer.roleDetails.customer}
                      updatedDetail={this.state.updatedDetailedSettings}
                      lang={this.props.lang}
                      ieDetailSettingTabData={this.onIeDetailSettingTabDataSubmit}
                      accounts={this.props.accounts}
                      oldTiers={this.props.interestEnhancement.interestEnhancement.tierSettings}
                      caseId={caseId}
                      history={this.props.history}
                      match={this.props.match}
                      pageState={this.state}
                      eChannels={this.state.echannels}
                    />
                  </div>
                </div>
              </NavListAccordion>
            }
          </NavListAccordionWrapper>
          <div className="save-btn-right">
            <button onClick={this.submitForm} className='btn save-btn'>{this.translations(this.state.pageJson.button_saveAndReturn.text)}</button>
          </div>
        </div>)
    } else {
      return (<div></div>);
    }
  }
}

// Basic Detail Payload
class payloadBasicDetail {
  constructor(props) {
    this.data = {};
    this.data.interestEnhancement = {}
  }

  setPayload(data) {
    switch (data.name) {
      case "basicDetails":
        const { interestEnhancementTitle, marginApplicable, id, lid, glsAgent, relationshipBank } = data.value;
        this.data.interestEnhancementTitle = interestEnhancementTitle;
        this.data.marginApplicable = marginApplicable;
        this.data.glsAgent = glsAgent;
        this.data.relationshipBank = relationshipBank;
        this.data.id = id;
        this.data.lid = lid;
        break;
      default:
    }
  }
  getPayload() {
    if ('interestEnhancement' in this.data) {
      return this.data;
    } else {
      return {
        ...this.data,
        interestEnhancement: {}
      }
    }
  }
}

// Tier setting payload
class payloadIeTierSetting {
  constructor(props) {
    this.data = {};
    this.data.interestEnhancement = {};
  }

  setPayload(data) {
    switch (data.name) {
      case "IETireSetting":
        this.data.interestEnhancement.tierSettings = data.value.tierSettings;
        break;
      default:
    }
  }

  getPayload() {
    if ('interestEnhancement' in this.data) {
      return this.data;
    } else {
      return {
        ...this.data,
        interestEnhancement: {}
      }
    }
  }
}

// Detail setting payload
class payloadIeDetailSetting {
  constructor(props) {
    this.data = {};
    this.data.interestEnhancement = {};
  }

  setPayload(data) {
    switch (data.name) {
      case "IEDetailSetting":
        this.data.interestEnhancement.detailedSettings = data.value.map(item => {
          if (item.interestContribution === undefined) {
            item.interestContribution = {
              name: "Interest Contribution",
              value: "Interest Contribution"
            }
          }
          return item;
        })
        break;
      default:
    }
  }

  getPayload() {
    if ('interestEnhancement' in this.data) {
      return this.data;
    } else {
      return {
        ...this.data,
        interestEnhancement: {}
      }
    }
  }
}

// E-Channel Reporting Section Payload
class EchannelReportingSection {
  constructor() {
    this.data = {}
    this.data.interestEnhancement = {};
  }

  setEchannelReporting({ reportedEChannelId, eChannelReported }) {
    this.data.interestEnhancement.reportedEChannelId = reportedEChannelId;
    this.data.interestEnhancement.eChannelReported = eChannelReported;
  }

  getPayload() {
    if ('interestEnhancement' in this.data) {
      return this.data;
    } else {
      return {
        ...this.data,
        interestEnhancement: {}
      }
    }
  }
}

class payloadIE {
  constructor(props) {
    this.data = {};
    this.data.interestEnhancement = {};
  }

  setPayload(data) {
    switch (data.name) {
      case "basicDetails":
        const { interestEnhancementTitle, marginApplicable, id, lid, glsAgent, relationshipBank } = data.value;
        this.data.interestEnhancementTitle = interestEnhancementTitle;
        this.data.marginApplicable = marginApplicable;
        this.data.glsAgent = glsAgent;
        this.data.relationshipBank = relationshipBank;
        this.data.id = id;
        this.data.lid = lid;
        break;
      case "IETireSetting":
        this.data.interestEnhancement.tierSettings = data.value.tierSettings;
        break;
      case "IEDetailSetting":
        this.data.interestEnhancement.detailedSettings = data.value.map(item => {
          if (item.interestContribution === undefined) {
            item.interestContribution = {
              name: "Interest Contribution",
              value: "Interest Contribution"
            }
          }
          return item;
        })
        break;
      case 'EChannelReporting':
        const { eChannelReported, reportedEChannelId } = data.value
        this.data.interestEnhancement.eChannelReported = eChannelReported;
        this.data.interestEnhancement.reportedEChannelId = reportedEChannelId;
        break;
      default:

    }
  }
  getPayload() {
    if ('interestEnhancement' in this.data) {
      return this.data;
    } else {
      return {
        ...this.data,
        interestEnhancement: {}
      }
    }
  }
}
const mapStateToProps = state => ({
  tabStatus: state.currentProductInterestEnhancement.ieTabStatus,
  CurrentProductEchannel: state.CurrentProductEchannel,
  entities: state.entities,
  customer: state.auth.userDetails,
  interestEnhancement: state.currentProductInterestEnhancement.data,
  accounts: state.currentProductInterestEnhancement.accounts,
  lang: state.lang,
  deletedIndex: state.currentProductInterestEnhancement.deletedIndex,
})

const mapDispatchToProps = dispatch => {
  return {
    setCurrentProductEchannel: productsechanneldata => {
      dispatch(setCurrentProductEchannel(productsechanneldata))
    },
    setInterestEnhancementDetail: data => {
      dispatch(setInterestEnhancementDetail(data))
    },
    setPremiumMarginValue: val => {
      dispatch(setPremiumMarginValue(val))
    },
    setIETabStatus: data => {
      dispatch(setIETabStatus(data))
    },
    setInterestEnhancementAccounts: accounts => {
      dispatch(setInterestEnhancementAccounts(accounts));
    },
    resetDeletedtTierIndex: () => {
      dispatch(resetDeletedtTierIndex())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CaptureProductGlsInterestEnhancement);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsInterestEnhancement/index.js